import request from "@/utils/request";
import { IEviBusinessbehavior } from "../model/evibusinessbehavior";

// 实体
export const defaultEviBusinessbehaviorData: IEviBusinessbehavior = {
  id: "",
  businessId: "",
  behaviorName: "",
  behaviorSubjectId: "",
  indexNo: 0,
  createTime: 0,
  behaviorObjectSubject: "",
  behaviorDate: 0,
  behaviorAction: "",
  behaviorContent: "",
  creatorId: "",
  updateTime: 0,
  isActive: 0,
  updateId: "",
  sort: 0
};

export const getEviBusinessbehavior = (id: any) => {
  request({
    url: "/EviBusinessbehavior/Get",
    method: "post",
    params: { id: id }
  });
};

export const addEviBusinessbehavior = (data: any) =>
  request({
    url: "/EviBusinessbehavior/Add",
    method: "post",
    data
  });

export const updateEviBusinessbehavior = (data: any) =>
  request({
    url: "/EviBusinessbehavior/Update",
    method: "post",
    data
  });

export const deleteEviBusinessbehavior = (id: string) =>
  request({
    url: "/EviBusinessbehavior/Delete",
    method: "post",
    params: { id: id }
  });

export const getEviBusinessbehaviorPageList = (data: any) =>
  request({
    url: "/EviBusinessbehavior/GetPageListAsync",
    method: "post",
    data
  });

export const getEviBusinessbehaviorArr = () =>
  request({
    url: "/EviBusinessbehavior/GetEviBusinessbehaviorArr",
    method: "post"
  });
export const getBehaviorArrByBusinessId = (businessId: string) =>
  request({
    url: "/EviBusinessbehavior/GetBehaviorArrByBusinessId",
    method: "post",
    params: { businessId: businessId }
  });
